import { loader } from "graphql.macro";
import { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import { executeGraphqlQuery } from "../../graphql/api";
import { formatDateTime } from "../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "../avatar/Avatar";
import { ImageDetails } from "../chatContent/ChatContent";
import Dialog from "../dialog/Dialog";
import ImageViewer from "../ImageViewer/ImageViewer";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { SNACKBAR } from "../../utils/constants";

const useImageLoaded = () => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef<HTMLImageElement>(null);

  const onLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    if (ref && ref.current && ref.current.complete) {
      onLoad();
    }
  });

  return { ref, loaded, onLoad };
};
export default function ChatContentItem({
  animationDelay,
  customer,
  item,
  unread,
  scrollToBottom,
  setSpinner,
}: any) {
  const [imageOpen, setImageOpen] = useState(false);
  const { ref, loaded, onLoad } = useImageLoaded();
  const [imageData, setImageData] = useState<any[]>([]);
  const [uniqueData, setUniqueData] = useState<string[]>([]);
  const getImagesByConversation = loader(
    "../../graphql/queries/getImagesByConversation.graphql"
  );
 // let location = useLocation();

  const dispatch = useDispatch();
  const query = new URLSearchParams(window?.location?.search);
  const variable = { conversationId: query.get("id") };
  const name =
    item?.from?.name && item?.from?.name[0] === "+"
      ? customer?.name
      : item?.from?.name;
  const date = item.createdTime && formatDateTime(item?.createdTime);
  let [message, senderName] = item?.message.split("\n");
  useEffect(() => {
    if (loaded) {
      scrollToBottom();
    }
  }, [loaded]);

  const getImageData = () => {
    setSpinner(true);

    executeGraphqlQuery(getImagesByConversation, variable)
      .then((res: any) => {
        const conversationsResponse: ImageDetails[] =
          res.data.getImagesByConversation;
        if (conversationsResponse.length > 0) {
          setImageData(conversationsResponse);
          setImageOpen(true);
          setUniqueData([
            ...Array.from(
              new Set(
                conversationsResponse.map((element) =>
                  element.createdTimestamp.slice(0, 10)
                )
              )
            ),
          ]);
          setSpinner(false);
        } else {
          setSpinner(false);
          dispatch(
            snackbarOpen({
              open: true,
              message: "No Images found",
              type: SNACKBAR.ERROR,
            })
          );
        }
      })
      .catch((error) => {
        setSpinner(false);
        console.log(error.message);
        dispatch(
          snackbarOpen({
            open: true,
            message: "Something went wrong",
            type: SNACKBAR.ERROR,
          })
        );
      });
  };
  const handleShowDialog = (isOpen: boolean) => {
    getImageData();
  };

  function getFormattedMessage(text: string) {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    let msg = text.replace(urlRegex, function (url: any) {
      return '<a href="' + url + '" target="_blank">' + url + "</a>";
    });
    return msg + (senderName ? "<br/>" + senderName : "");
  }

  return (
    <div data-testid="chatContentItem">
      {unread && <div className="separator">New Messages</div>}

      {imageOpen && (
        <ImageViewer
          setDialogOpen={setImageOpen}
          imageId={item.messageId}
          preview={true}
          imageData={imageData}
          uniqueData={uniqueData}
        />
      )}
      <div
        style={{ animationDelay: `0.8s`, position: "relative" }}
        className={`chat-item ${item.type}`}
      >
        <div className="chat-item-content">
          <div className="chat-name">
            <span>
              {item.type === "received"
                ? `${name} - ${date}`
                : `${date} - ${name}`}
            </span>
          </div>
          {item.contentType?.includes("image") && (
            <img
              ref={ref}
              src={item.message}
              alt={item.message}
              style={{ cursor: "pointer", maxWidth: "60%" }}
              onClick={() => handleShowDialog(true)}
              onLoad={onLoad}
            />
          )}
          {item.contentType?.includes("video") && (
            <>
              <ReactPlayer
                width={320}
                height={240}
                controls
                url={[
                  { src: item.message, type: "video/mp4" },
                  { src: item.message, type: "video/webm" },
                  { src: item.message, type: "video/ogg" },
                  { src: item.message, type: "video/3gpp" }
                ]}
                onError={(e) => console.log(e)}
              />
              <p style={{ marginBottom: 10 }}>
                <a href={item.message}>Download the video file</a>.
              </p>
            </>
          )}
          {!item.contentType && (
            <div
              className={`chat-msg ${senderName ? "adjuster" : "customer"}`}
              style={{textAlign:"start"}}
              data-testid="message"
              dangerouslySetInnerHTML={{ __html: getFormattedMessage(message) }}
            ></div>
          )}
          {item.pending && (
            <div className="chat-meta">
              <span>sending....</span>
            </div>
          )}
        </div>
        <Avatar name={name} />
      </div>
    </div>
  );
}
